import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, InjectionToken, Provider } from '@angular/core';
import { Observable } from 'rxjs';

export const API_URL = new InjectionToken<string>('API_URL');

export function provideApiUrl(url: string): Provider {
  return { provide: API_URL, useValue: url };
}

@Injectable({
  providedIn: 'root',
})
export class SharedDataAccessApiService {
  private readonly API_URL = inject(API_URL);

  get headers(): HttpHeaders {
    const headersConfig = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    return new HttpHeaders(headersConfig);
  }

  constructor(private http: HttpClient) {}

  get<T>(url: string, options = {}): Observable<T> {
    return this.http.get<T>(`${this.API_URL}${url}`, {
      headers: this.headers,
      ...options,
    });
  }

  externalGet<T>(url: string, options = {}): Observable<T> {
    return this.http.get<T>(url, { headers: this.headers, ...options });
  }

  post<T, D>(url: string, body: D, options = {}): Observable<T> {
    if (body instanceof FormData) {
      return this.http.post<T>(`${this.API_URL}${url}`, body, {
        ...options,
      });
    }
    return this.http.post<T>(`${this.API_URL}${url}`, JSON.stringify(body), {
      headers: this.headers,
      ...options,
    });
  }

  put<T, D>(url: string, data: D): Observable<T> {
    return this.http.put<T>(`${this.API_URL}${url}`, JSON.stringify(data), {
      headers: this.headers,
    });
  }

  delete<T, D = void>(url: string, body?: D): Observable<T> {
    return this.http.delete<T>(`${this.API_URL}${url}`, {
      headers: this.headers,
      body,
    });
  }
}
